// extracted by mini-css-extract-plugin
export default {"tabs":"tabs","activeTab":"activeTab"};